import gql from 'graphql-tag';

export default gql`
  mutation removeOrderItems($orderItemIds: [ID!]!) {
    removeOrderItems(orderItemIds: $orderItemIds) {
      order {
        items {
          id
        }
        price {
          total
          balanceDue
        }
      }
      errors
    }
  }
`;
